import { Modal, Form, Input, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { mixGetV1 } from "../services/mixin";

const removeAccents = (str: string) =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");

const BranchModal = ({ open, onClose, onSubmit, initialData }: any) => {
    const [form] = Form.useForm();
    const [cities, setCities] = useState<any[]>([]);
    const [wards, setWards] = useState<any[]>([]);
    const [loadingCities, setLoadingCities] = useState(false);
    const [loadingWards, setLoadingWards] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Load danh sách tỉnh thành
    useEffect(() => {
        const fetchCities = async () => {
            setLoadingCities(true);
            try {
                const res = await mixGetV1('/api/v1/be/provinces');
                if (res?.status) {
                    const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
                    setCities(list);
                }
            } catch (error) {
                console.error('Failed to load cities:', error);
            } finally {
                setLoadingCities(false);
            }
        };
        if (open) fetchCities();
    }, [open]);

    useEffect(() => {
        if (initialData) {
            form.setFieldsValue(initialData);
            if (initialData.city) {
                fetchWards(initialData.city);
            }
        } else {
            form.resetFields();
            setWards([]);
        }
    }, [initialData, open]);

    const fetchWards = async (provinceCode: string) => {
        setLoadingWards(true);
        try {
            const res = await mixGetV1('/api/v1/be/wards', { province_code: provinceCode });
            if (res?.status) {
                const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
                setWards(list);
            } else {
                setWards([]);
            }
        } catch (error) {
            console.error('Failed to load wards:', error);
            setWards([]);
        } finally {
            setLoadingWards(false);
        }
    };

    const handleCityChange = (value: string) => {
        form.setFieldsValue({ ward: undefined });
        setWards([]);
        fetchWards(value);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);
            const success = await onSubmit(values);
            if (success) {
                onClose();
            }
        } catch (error) {
            // validation failed
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="Thông tin chi nhánh"
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            okText="Lưu"
            cancelText="Hủy"
            width={700}
            confirmLoading={submitting}
        >
            <Form layout="vertical" form={form}>
                {/* Tên chi nhánh */}
                <Form.Item
                    label="Tên chi nhánh"
                    name="name"
                    rules={[{ required: true, message: "Nhập tên chi nhánh" }]}
                >
                    <Input className="rounded-full" />
                </Form.Item>

                {/* Địa chỉ */}
                <Form.Item label="Địa chỉ" name="address">
                    <Input className="rounded-full" />
                </Form.Item>

                {/* Tỉnh + Phường */}
                <Row gutter={12}>
                    <Col span={12}>
                        <Form.Item label="Tỉnh thành" name="city">
                            <Select
                                className="rounded-full"
                                onChange={handleCityChange}
                                placeholder="Chọn tỉnh"
                                loading={loadingCities}
                                showSearch
                                filterOption={(input, option) => {
                                    const label = removeAccents((option?.children as unknown as string) || '').toLowerCase();
                                    const keyword = removeAccents(input).toLowerCase();
                                    return label.includes(keyword);
                                }}
                            >
                                {cities.map((c: any) => (
                                    <Select.Option key={c.code || c.id} value={c.code}>
                                        {c.full_name || c.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Phường/Xã" name="ward">
                            <Select
                                className="rounded-full"
                                placeholder="Chọn phường"
                                loading={loadingWards}
                                showSearch
                                filterOption={(input, option) => {
                                    const label = removeAccents((option?.children as unknown as string) || '').toLowerCase();
                                    const keyword = removeAccents(input).toLowerCase();
                                    return label.includes(keyword);
                                }}
                            >
                                {wards.map((w: any) => (
                                    <Select.Option key={w.code || w.id} value={w.code}>
                                        {w.full_name || w.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                {/* Email */}
                <Form.Item label="Email" name="email">
                    <Input className="rounded-full" />
                </Form.Item>

                {/* SĐT */}
                <Form.Item label="Số điện thoại" name="phone">
                    <Input className="rounded-full" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default BranchModal;